<template>
  <div class="sidebar"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor">
    <!--
            Tip 1: you can change the color of the sidebar's background using: data-background-color="white | black | darkblue"
            Tip 2: you can change the color of the active button using the data-active-color="primary | info | success | warning | danger"
        -->
    <!-- -->
    <div class="sidebar-wrapper" id="style-3">
      <div class="logo">
        
            <div class="logo-img">
                <img src="@/assets/img/logo_uhl.png" height="30px" alt="">
            </div>
          <a href="#" class="simple-text">
        </a>
      </div>
      <slot>

      </slot>
      <ul class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot name="links">
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="index"
                        :to="link.path"
                        :name="link.name"
                        :icon="link.icon">
          </sidebar-link>
        </slot>
      </ul>
      <moving-arrow :move-y="arrowMovePx">

      </moving-arrow>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase';
import MovingArrow from "./MovingArrow.vue";
import SidebarLink from "./SidebarLink";
export default {
  props: {
    title: {
      type: String,
      default: "Rewe Dagli"
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["white", "black", "darkblue"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: "danger",
      validator: value => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink
    };
  },
  components: {
    MovingArrow,
    SidebarLink
  },
  computed: {
    /**
     * Styles to animate the arrow near the current active sidebar link
     * @returns {{transform: string}}
     */
    arrowMovePx() {
      if(this.activeLinkIndex > 0 || this.fahrer){
        return this.linkHeight * this.activeLinkIndex+70;
      } else if(!this.isLoggedIn){
        return this.linkHeight * this.activeLinkIndex-75;
      }
      return this.linkHeight * this.activeLinkIndex;
    }
  },
  data() {
    return {
      linkHeight: 65,
      activeLinkIndex: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      links: [],
      allowedForDashboard: false,
      isLoggedIn: false,
      // uhl: false,
      fahrer: false,
      büro: false,
      temp: false,
      reinigung: false,
      uhlmail: "rema.uhl@gmx.de",
      fahrermails: ["fahrer1@heimspiel.de", "fahrer2@heimspiel.de"],
      tempmails: ["temp1@heimspiel.de", "temp2@heimspiel.de"],
      reinigungmails: ["reinigung@heimspiel.de"],
      büromail: "buero@heimspiel.de"
    };
  },
  methods: {
    findActiveLink() {
      this.links.forEach((link, index) => {
        if (link.isActive()) {
          this.activeLinkIndex = index;
        }
      });
    },
    addLink(link) {
      const index = this.$slots.links.indexOf(link.$vnode);
      this.links.splice(index, 0, link);
    },
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index > -1) {
        this.links.splice(index, 1);
      }
    }
  },
  mounted() {
    this.$watch("$route", this.findActiveLink, {
      immediate: true
    });
  },
  created: function(){
    if(firebase.auth().currentUser){
      this.isLoggedIn = true;
      var mail = firebase.auth().currentUser.email;
      if (mail === this.uhlmail) {
        this.allowedForDashboard = true;
      }
      else if (mail === this.büromail) {
        this.büro = true;
      }
      else if (mail === this.fahrermails[0] || mail === this.fahrermails[1]){
        this.fahrer = true;
      }
      else if (mail === this.tempmails[0] || mail === this.tempmails[1]){
        this.temp = true;
      }
      else if (mail === this.reinigungmails[0]){
        this.reinigung = true;
      }
    }
  }
};
</script>
<style scoped>
.logo-img{
  padding-bottom: 0px;
  padding-top: 10px;
  padding-left: 15%;
  width: 50%;
  height: 100%;
}
</style>
